import React from 'react';

class AnimatedNumber extends React.Component {
  constructor(props) {
    super(props);
    const { numericValue, suffix } = this.parseValue(props.value);

    this.state = {
      displayValue: 0,
      animated: false,
      numericValue,
      suffix,
    };

    this.ref = React.createRef();
    this.observer = null;
    this.animationFrame = null;
  }

  componentDidMount() {
    this.setupIntersectionObserver();
  }

  componentWillUnmount() {
    if (this.observer) this.observer.disconnect();
    cancelAnimationFrame(this.animationFrame);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      const { numericValue, suffix } = this.parseValue(this.props.value);
      this.setState({ numericValue, suffix, displayValue: 0, animated: false }, () => {
        this.setupIntersectionObserver();
      });
    }
  }

  parseValue = (val) => {
    if (!val) return { numericValue: 0, suffix: '' };
    const match = val.toString().match(/^(\d+(?:\.\d+)?)(.*)$/);
    const number = match ? parseFloat(match[1]) : 0;
    const suffix = match ? match[2] : '';
    return { numericValue: number, suffix };
  };

  setupIntersectionObserver = () => {
    if (!this.ref.current) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.state.animated) {
            this.startAnimation();
            this.setState({ animated: true });
            this.observer.disconnect(); // stop observing after triggering
          }
        });
      },
      { threshold: 0.5 } // at least 50% visible
    );

    this.observer.observe(this.ref.current);
  };

  startAnimation = () => {
    const duration = this.props.duration || 1000;
    const start = performance.now();

    const animate = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const current = Math.floor(progress * this.state.numericValue);
      this.setState({ displayValue: current });

      if (progress < 1) {
        this.animationFrame = requestAnimationFrame(animate);
      } else {
        this.setState({ displayValue: this.state.numericValue });
      }
    };

    this.animationFrame = requestAnimationFrame(animate);
  };

  render() {
    const { displayValue, suffix } = this.state;
    const { style = {} } = this.props;

    return (
      <span ref={this.ref} style={style}>
        {displayValue.toLocaleString()}{suffix}
      </span>
    );
  }
}

export default AnimatedNumber;
